import { RegisterOptions, useFormContext } from "react-hook-form";

import { useInterpolate } from "utils/prismic-utils";

import CheckboxButton from "../checkboxButton/CheckboxButton";

import styles from "./CheckboxGroup.module.scss";

type CheckboxGroupProps = {
  desktopColumns?: number;
  mobileColumns?: number;
  name: string;
  options: Record<string, string>;
  registerOptions: RegisterOptions;
};

export default function CheckboxGroup({
  mobileColumns = 2,
  desktopColumns = mobileColumns,
  name,
  options,
  registerOptions,
}: CheckboxGroupProps) {
  const { register } = useFormContext();

  const interpolate = useInterpolate();

  return (
    <div
      className={styles.cardsGroup}
      role="radiogroup"
      style={
        {
          "--desktop-columns": desktopColumns,
          "--mobile-columns": mobileColumns,
        } as any
      }
    >
      {Object.entries(options).map(([id, label]) => (
        <CheckboxButton
          key={id}
          id={id}
          label={interpolate(label)}
          value={id}
          {...register(name, registerOptions)}
        />
      ))}
    </div>
  );
}
